import "./ExpertServices.module.css";
import Header from "@/reusable_sections/Header";
import OurFullCapability from "./sections/OurFullCapability";
import MaterialShowcase from "./sections/MaterialShowcase";
import ReadyToBegin from "./sections/ReadyToBegin";
import Footer from "@/reusable_sections/Footer";
export default function ExpertServicesPage() {
  return <div>
      <Header />
      <OurFullCapability />
      <MaterialShowcase />
      <ReadyToBegin />
      <Footer />
    </div>;
}